import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { EClientData } from "dto/IClient";
import StarIcon from "assets/icons/star.svg?react";
import CloseIcon from "assets/icons/close.svg?react";
import CopyIcon from "assets/icons/copye.svg?react";
import { Tooltip } from "@mui/material";

const EmailClientModal: FC<Props> = ({ client, refWrapper }) => {
  if (!refWrapper?.current) return <></>;

  const position = refWrapper.current.getBoundingClientRect();

  const emails = client.Data.filter((d) => d.Type === EClientData.EMAIL);

  return ReactDOM.createPortal(
    <div
      style={{
        left: `${position.left}px`,
        top: `${position.top + 32}px`,
      }}
      className={styles.wrapper}
    >
      <div className={styles.title}>
        Email
        <CloseIcon className={styles.icon} />
      </div>
      {emails.map((e) => (
        <div className={styles.box}>
          <div className={styles.name}>{e.Value}</div>
          <div className={styles.options}>
            <Tooltip title="Kopiuj">
              <div>
                <CopyIcon
                  className={`${styles.icon} ${styles.copy}`}
                  onClick={() => {
                    navigator.clipboard.writeText(e.Value ?? "");
                  }}
                />
              </div>
            </Tooltip>
            {e.IsMain && <StarIcon className={styles.icone} />}
          </div>
        </div>
      ))}
    </div>,
    document.body
  );
};

export default EmailClientModal;
